import i18n from 'i18next';

const getRoundTypeLabel = (type: string) => {
  return i18n.t(`roundType.${type}`);
};
export default getRoundTypeLabel;
